// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file payloads.proto (package river, syntax proto3)
/* eslint-disable */
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file payloads.proto.
 */
export const file_payloads = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_empty]);
/**
 * Describes the message river.ChannelMessage.
 * Use `create(ChannelMessageSchema)` to create a new message.
 */
export const ChannelMessageSchema = /*@__PURE__*/ messageDesc(file_payloads, 0);
/**
 * Describes the message river.ChannelMessage.Reaction.
 * Use `create(ChannelMessage_ReactionSchema)` to create a new message.
 */
export const ChannelMessage_ReactionSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 0);
/**
 * Describes the message river.ChannelMessage.Edit.
 * Use `create(ChannelMessage_EditSchema)` to create a new message.
 */
export const ChannelMessage_EditSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 1);
/**
 * Describes the message river.ChannelMessage.Redaction.
 * Use `create(ChannelMessage_RedactionSchema)` to create a new message.
 */
export const ChannelMessage_RedactionSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 2);
/**
 * Describes the message river.ChannelMessage.Post.
 * Use `create(ChannelMessage_PostSchema)` to create a new message.
 */
export const ChannelMessage_PostSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3);
/**
 * Describes the message river.ChannelMessage.Post.Mention.
 * Use `create(ChannelMessage_Post_MentionSchema)` to create a new message.
 */
export const ChannelMessage_Post_MentionSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 0);
/**
 * Describes the message river.ChannelMessage.Post.RoleMention.
 * Use `create(ChannelMessage_Post_RoleMentionSchema)` to create a new message.
 */
export const ChannelMessage_Post_RoleMentionSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 1);
/**
 * Describes the message river.ChannelMessage.Post.Attachment.
 * Use `create(ChannelMessage_Post_AttachmentSchema)` to create a new message.
 */
export const ChannelMessage_Post_AttachmentSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 2);
/**
 * Describes the message river.ChannelMessage.Post.Content.
 * Use `create(ChannelMessage_Post_ContentSchema)` to create a new message.
 */
export const ChannelMessage_Post_ContentSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3);
/**
 * Describes the message river.ChannelMessage.Post.Content.Text.
 * Use `create(ChannelMessage_Post_Content_TextSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_TextSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 0);
/**
 * Describes the message river.ChannelMessage.Post.Content.Image.
 * Use `create(ChannelMessage_Post_Content_ImageSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_ImageSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 1);
/**
 * Describes the message river.ChannelMessage.Post.Content.Image.Info.
 * Use `create(ChannelMessage_Post_Content_Image_InfoSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_Image_InfoSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 1, 0);
/**
 * Describes the message river.ChannelMessage.Post.Content.GM.
 * Use `create(ChannelMessage_Post_Content_GMSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_GMSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 2);
/**
 * Describes the message river.ChannelMessage.Post.Content.EmbeddedMessage.
 * Use `create(ChannelMessage_Post_Content_EmbeddedMessageSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_EmbeddedMessageSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 3);
/**
 * Describes the message river.ChannelMessage.Post.Content.EmbeddedMessage.Info.
 * Use `create(ChannelMessage_Post_Content_EmbeddedMessage_InfoSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_EmbeddedMessage_InfoSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 3, 0);
/**
 * Describes the message river.ChannelMessage.Post.Content.EmbeddedMessage.StaticInfo.
 * Use `create(ChannelMessage_Post_Content_EmbeddedMessage_StaticInfoSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_EmbeddedMessage_StaticInfoSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 3, 1);
/**
 * Describes the message river.ChannelMessage.Post.Content.UnfurledURL.
 * Use `create(ChannelMessage_Post_Content_UnfurledURLSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_UnfurledURLSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 4);
/**
 * Describes the message river.ChannelMessage.Post.Content.UnfurledURL.Image.
 * Use `create(ChannelMessage_Post_Content_UnfurledURL_ImageSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_UnfurledURL_ImageSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 4, 0);
/**
 * Describes the message river.ChannelMessage.Post.Content.Ticker.
 * Use `create(ChannelMessage_Post_Content_TickerSchema)` to create a new message.
 */
export const ChannelMessage_Post_Content_TickerSchema = /*@__PURE__*/ messageDesc(file_payloads, 0, 3, 3, 5);
/**
 * Describes the message river.ChannelProperties.
 * Use `create(ChannelPropertiesSchema)` to create a new message.
 */
export const ChannelPropertiesSchema = /*@__PURE__*/ messageDesc(file_payloads, 1);
/**
 * Describes the message river.UserMetadataProperties.
 * Use `create(UserMetadataPropertiesSchema)` to create a new message.
 */
export const UserMetadataPropertiesSchema = /*@__PURE__*/ messageDesc(file_payloads, 2);
/**
 * Describes the message river.FullyReadMarkers.
 * Use `create(FullyReadMarkersSchema)` to create a new message.
 */
export const FullyReadMarkersSchema = /*@__PURE__*/ messageDesc(file_payloads, 3);
/**
 * Describes the message river.FullyReadMarkers.Content.
 * Use `create(FullyReadMarkers_ContentSchema)` to create a new message.
 */
export const FullyReadMarkers_ContentSchema = /*@__PURE__*/ messageDesc(file_payloads, 3, 0);
/**
 * Describes the message river.SessionKeys.
 * Use `create(SessionKeysSchema)` to create a new message.
 */
export const SessionKeysSchema = /*@__PURE__*/ messageDesc(file_payloads, 4);
/**
 * Describes the message river.HybridGroupSessionKey.
 * Use `create(HybridGroupSessionKeySchema)` to create a new message.
 */
export const HybridGroupSessionKeySchema = /*@__PURE__*/ messageDesc(file_payloads, 5);
/**
 * Describes the message river.MediaInfo.
 * Use `create(MediaInfoSchema)` to create a new message.
 */
export const MediaInfoSchema = /*@__PURE__*/ messageDesc(file_payloads, 6);
/**
 * Describes the message river.EmbeddedMedia.
 * Use `create(EmbeddedMediaSchema)` to create a new message.
 */
export const EmbeddedMediaSchema = /*@__PURE__*/ messageDesc(file_payloads, 7);
/**
 * Describes the message river.ChunkedMedia.
 * Use `create(ChunkedMediaSchema)` to create a new message.
 */
export const ChunkedMediaSchema = /*@__PURE__*/ messageDesc(file_payloads, 8);
/**
 * Describes the message river.ChunkedMedia.AESGCM.
 * Use `create(ChunkedMedia_AESGCMSchema)` to create a new message.
 */
export const ChunkedMedia_AESGCMSchema = /*@__PURE__*/ messageDesc(file_payloads, 8, 0);
/**
 * Describes the message river.UserBio.
 * Use `create(UserBioSchema)` to create a new message.
 */
export const UserBioSchema = /*@__PURE__*/ messageDesc(file_payloads, 9);
/**
 * Describes the message river.BearerToken.
 * Use `create(BearerTokenSchema)` to create a new message.
 */
export const BearerTokenSchema = /*@__PURE__*/ messageDesc(file_payloads, 10);
/**
 * Describes the message river.ExportedDevice.
 * Use `create(ExportedDeviceSchema)` to create a new message.
 */
export const ExportedDeviceSchema = /*@__PURE__*/ messageDesc(file_payloads, 11);
/**
 * Describes the message river.ExportedDevice.GroupSession.
 * Use `create(ExportedDevice_GroupSessionSchema)` to create a new message.
 */
export const ExportedDevice_GroupSessionSchema = /*@__PURE__*/ messageDesc(file_payloads, 11, 0);
/**
 * Describes the message river.ExportedDevice.HybridGroupSession.
 * Use `create(ExportedDevice_HybridGroupSessionSchema)` to create a new message.
 */
export const ExportedDevice_HybridGroupSessionSchema = /*@__PURE__*/ messageDesc(file_payloads, 11, 1);
//# sourceMappingURL=payloads_pb.js.map